'use strict';

var App = require('app');
var AppState = require('app_state');
var DeviceRestartDialog = require('components/devices/views/common/restart_device_dialog_view');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');
var Utils = require('components/common/utils');

var DeviceActionController = Marionette.Object.extend({
    setDeviceLockStatus: function (deviceID, view) {
        if (!AppState.canUnlockDevice(deviceID)) {
            Notification.show(
                'error',
                i18n.TR('Entsperren nicht möglich'),
                i18n.TR('Entsperren Sie das übergeordnete Gerät.')
            );
            return;
        }

        var wasLocked = AppState.deviceIsLocked(deviceID);
        App.ajax({
            method: 'POST',
            url: '/api/v1/devices/' + deviceID + '/lock',

            data: JSON.stringify({ lock: !wasLocked }),

            success: function (data) {
                Notification.show(
                    'success',
                    i18n.TR('Erfolg'),
                    wasLocked ? i18n.TR('Das Gerät wurde entsperrt.') : i18n.TR('Das Gerät wurde gesperrt.')
                );

                var entry = _.findWhere(view.data.actions[0].menu_items, { key: 'lock' });
                entry.name = !wasLocked ? i18n.TR('Gerät entsperren') : i18n.TR('Gerät sperren');
                entry.icon = !wasLocked ? 'fa fa-unlock' : 'fa fa-lock';

                view.render();
            },
            error: function (data) {
                Notification.show(
                    'error',
                    i18n.TR('Fehler'),
                    wasLocked
                        ? i18n.TR('Das Gerät konnte nicht entsperrt werden.')
                        : i18n.TR('Das Gerät konnte nicht gesperrt werden.')
                );
            },
        });
    },

    doReset: function (device_id) {
        var self = this;
        Utils.showConfirmationDialog({
            title: i18n.TR('Gerät neustarten'),
            hint:
                i18n.TR('Das Gerät wird neu gestartet.') +
                ' ' +
                i18n.TR('Es wird vorübergehend nicht erreichbar sein.') +
                '<br />' +
                i18n.TR('Sind Sie sicher?'),
            action_label: i18n.TR('Neustarten'),
            action_cb: function () {
                // wait till previous confirmation dialog totally disappear
                $('#js-modal-dialog').one('hidden.bs.modal', function () {
                    self.restartDevice(device_id);
                });
            },
        });
    },

    doArchive: function (device_id, view) {
        var self = this;
        Utils.showConfirmationDialog({
            title: i18n.TR('Gerät archivieren'),
            hint:
                i18n.TR('Die Daten des Gerätes und aller daran angeschlossenen Geräte werden archiviert.') +
                ' ' +
                i18n.TR('Nach der Archivierung werden keine neuen Daten mehr gesammelt.') +
                ' ' +
                i18n.TR('Der Schreibzugriff wird für alle Nutzer deaktiviert.') +
                '<br/><br/><div class="alert alert-danger"><b>' +
                i18n.TR('Achtung: Diese Aktion kann nicht rückgängig gemacht werden!') +
                '</b></div>' +
                i18n.TR('Wollen Sie das Gerät wirklich archivieren?'),
            action_label: i18n.TR('Archivieren'),
            action_cb: function () {
                // wait till previous confirmation dialog totally disappears
                $('#js-modal-dialog').one('hidden.bs.modal', function () {
                    self.archiveDevice(device_id, view);
                });
            },
        });
    },

    archiveDevice: function (device_id, view) {
        App.ajax({
            url: '/api/v1/devices/' + device_id + '/archive',
            type: 'POST',

            success: function (data) {
                Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Das Gerät wurde archiviert.'));
                // reload page
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
            error: function (data) {
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Das Gerät konnte nicht archiviert werden.'));
            },
        });
    },

    restartDevice: function (device_id) {
        App.showModal(
            new DeviceRestartDialog({
                device: device_id,
                controller: this,
            })
        );
    },

    restartDevicePhase: function (params) {
        if (params.phase >= 4) {
            // do nothing
            return;
        }

        App.ajax({
            url: '/api/v1/devices/' + params.device + '/restart/' + params.phase,
            type: 'POST',

            success: function () {
                params.success_cb();
            },
            error: function (xhr) {
                if (params.phase == 2) {
                    // error expected -> reset kills device connection
                    params.success_cb();
                } else {
                    params.error_cb(
                        xhr.responseJSON || {
                            error: xhr.responseText,
                        }
                    );
                }
            },
        });
    },
});

module.exports = DeviceActionController;
